import { render, staticRenderFns } from "./ConfirmProfile.vue?vue&type=template&id=57fb2721&scoped=true&"
import script from "./ConfirmProfile.vue?vue&type=script&lang=js&"
export * from "./ConfirmProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb2721",
  null
  
)

export default component.exports